import { render, staticRenderFns } from "./ChartDonutPercent.vue?vue&type=template&id=153a745a&scoped=true&"
import script from "./ChartDonutPercent.vue?vue&type=script&lang=js&"
export * from "./ChartDonutPercent.vue?vue&type=script&lang=js&"
import style0 from "./ChartDonutPercent.vue?vue&type=style&index=0&id=153a745a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "153a745a",
  null
  
)

export default component.exports